import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, preventDoubleTapToZoom, media } from '@mgmresorts/wcl-styled';
import React from 'react';
import { Text10 } from '../../Text/Text.es.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  flex-direction: ", ";\n\n  :focus-visible {\n    outline: solid 2px ", ";\n    outline-offset: 2px;\n  }\n"])), preventDoubleTapToZoom, function (p) {
  return p.labelPlacement === 'left' ? 'row' : 'row-reverse';
}, function (p) {
  return p.theme.colors.outlineColor;
});
var StyledLabels = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-grow: 1;\n  cursor: default;\n"])));
var StyledLabel = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: ", ";\n  line-height: 20px;\n  font-weight: 500;\n  color: ", ";\n  ", "\n"])), function (p) {
  return p.labelSize === 'small' ? '12px' : p.labelSize === 'medium' ? '16px' : p.labelSize === 'large' ? '20px' : p.labelSize === 'x-large' ? '24px' : '16px';
}, function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.labelSize === 'small' && media.minMd(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      font-size: 16px;\n    "])));
});
var StyledChildren = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  ", ": 8px;\n"])), function (p) {
  return p.labelPlacement === 'left' ? 'margin-left' : 'margin-right';
});
/**
 * Renders a <Field /> component
 * @param {string | JSX.Element} label - Main label
 * @param {string} labelSize - Label text size.
 * @param {string} description - Additional description
 * @param {boolean} focusable - If focusable, field can be focused with keyboard.
 * @param {string} labelPlacement - Describes the label (and description) placement.
 * @param {string} id - set the id on the element
 * @param {string} className - set the class on the element
 * @param {string} role - set the role on the element
 * @param {void} onClick - attach a event listener on the element
 * @param {React.ReactNode} children - the children to be rendered inside the Field
 * @param {React.ReactNode | React.ReactNodeArray} labelInfo - set additional labelInfo
 **/

var Field = function Field(props) {
  var handleKeyDown = function handleKeyDown(e) {
    if (['Enter', 'Space', 'Spacebar', ' '].includes(e.key)) {
      e.preventDefault();

      if (props.onClick) {
        props.onClick();
      }
    }
  };

  var ariaLabelId = props.id && props.label ? "".concat(props.id, "__label") : undefined;
  var ariaDescriptionId = props.id && props.description ? "".concat(props.id, "__description") : undefined;
  var labelInfo = props.labelInfo && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onKeyPress: function onKeyPress(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    role: "button",
    tabIndex: 0
  }, props.labelInfo);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    id: props.id,
    className: props.className,
    role: props.role,
    "aria-labelledby": ariaLabelId,
    "aria-describedby": ariaDescriptionId,
    tabIndex: props.focusable ? 0 : undefined,
    "aria-checked": props['aria-checked'],
    "aria-selected": props['aria-selected'],
    labelPlacement: props.labelPlacement,
    onClick: props.onClick,
    // It needs to be keydown not keypress,
    // in order to prevent scrolling on space key
    onKeyDown: handleKeyDown,
    "data-testid": Field.selector()
  }, (!!props.label || !!props.description) && /*#__PURE__*/React.createElement(StyledLabels, null, /*#__PURE__*/React.createElement(StyledLabel, {
    id: ariaLabelId,
    labelSize: props.labelSize
  }, props.label, labelInfo), /*#__PURE__*/React.createElement(Text10, {
    id: ariaDescriptionId,
    color: "#606060"
  }, props.description)), /*#__PURE__*/React.createElement(StyledChildren, {
    labelPlacement: props.labelPlacement
  }, props.children));
};

Field.selector = function () {
  return 'Field';
};

Field.defaultProps = {
  focusable: true,
  labelSize: 'medium',
  labelPlacement: 'left'
};

export { Field };
